<template>
  <div class="success">
    <div class="main-contents">
    <p class="title">ご登録ありがとうございます!</p>
    <p class="description">食生活の改善で健康的な暮らしを手に入れましょう！</p><br>
    <p class="description">ご登録頂いたメールならびにInstagramやLineのタイムラインに<br>レシピURLを送信致しますので<br>そちらからご確認をお願い致します！</p>
    <div class="flexbox">
      <section class="main">
        <div class="button-contents" style="padding:5%;">
          <a id="instagramButton" type="" href="">Instagramタイムラインでレシピを<br>確認する方はこちら</a>
          <label>InstagramId: <a href="https://www.instagram.com/7200kcal_recipe/" alt="7200Kcal公式アカウント">7200Kcal公式アカウント</a></label>
        </div>
      </section>
      <section class="side">
        <div class="button-contents" style="padding:5%;">
          <a id="lineButton" type="" href="">Lineタイムラインでレシピを<br>確認する方はこちら</a>
          <label>LineId: <a href="https://lin.ee/krWoQ2J" alt="7200Kcal公式アカウント">7200Kcal公式アカウント</a></label>
        </div>
      </section>
    </div>
    </div>
    <div class="wp-flexbox">
      <div class="flexbox">
        <section class="main">
          <img src="../../assets/third-content-1.jpg" alt="" />
        </section>
        <section class="side">
          <p>健康的なレシピや便利な買い物リスト</p>
          <button id="todayRecipeButton" type="" v-on:click="todayRecipe()">本日のレシピを確認</button>
        </section>
      </div>
      <div class="flexbox">
        <section class="main">
          <p>アカウント情報やお気に入りのレシピ</p>
          <button id="mypageButton" type="" v-on:click="mypage()">マイページはこちら</button>
        </section>
        <section class="side">
          <img src="../../assets/third-content-1.jpg" alt="" />
        </section>
      </div>
     </div>
     <div class="sp-flexbox">
      <div class="flexbox">
        <section class="main">
          <img src="../../assets/third-content-1.jpg" alt="" />
        </section>
        <section class="side">
          <p>健康的なレシピや便利な買い物リスト</p>
          <button id="todayRecipeButton" type="" v-on:click="todayRecipe()">本日のレシピを確認</button>
        </section>
      </div>
      <div class="flexbox">
        <section class="main">
          <img src="../../assets/third-content-1.jpg" alt="" />
        </section>
        <section class="side">
          <p>アカウント情報やお気に入りのレシピ</p>
          <button id="mypageButton" type="" v-on:click="mypage()">マイページはこちら</button>
        </section>
      </div>
     </div>
  </div>
</template>
<style scoped>
.success .main-contents{
  margin: 5% auto;
}
.success .main-contents .title{
  font-size: 32px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.success .main-contents .description{
  font-family: Hiragino Kaku Gothic Pro;
  margin-top: 0px;
  margin-bottom: 0px;
}
.main {
  width: 50%;
}
.side {
  width: 50%;
}
.main,
.side {
  border-radius: 10px
}
.success img{
  width: 100%;
}
#instagramButton{
  display: block;
  background:#3f729b;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 24px;
  margin:16px auto;
  border:0px;
}
#lineButton{
  display: block;
  background:#1dcd00;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 24px;
  margin:16px auto;
  border:0px;
}
#mypageButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 24px;
  margin:24px auto;
  border:0px;
}
#todayRecipeButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 24px;
  margin:24px auto;
  border:0px;
}
label{
 font-size: 12px;
 text-align: center;
 width: 100%;
 display: block;

}
.flexbox p{
  margin-top: 25%;
}
.sp-flexbox{
  display: none;
}
.wp-flexbox{
  display: block;
}
/* Responsive */
@media ( min-width : 600px ){
    .flexbox {
      display: -webkit-flex;
      display: flex;
      margin: 5% auto;
      width: 80%;
    }
}
@media ( max-width : 600px ){
#instagramButton{
  display: block;
  background:#3f729b;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:16px auto;
  border:0px;
}
#lineButton{
  display: block;
  background:#1dcd00;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:16px auto;
  border:0px;
}
#mypageButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
}
#todayRecipeButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
}
.sp-flexbox{
  display: block;
}
.wp-flexbox{
  display: none;
}
.flexbox p{
  margin-top: 5%;
}
.flexbox {
  margin-top: 64px;
  margin-bottom: 48px;
}
.success .main-contents .title {
    font-size: 24px;
}
.success .main-contents .description {
  font-size: 12px;
}
.success .main-contents{
  margin: 10% auto;
}
.main {
  width: 100%;
}
.side {
  width: 100%;
}
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'Success',
  components: {
  },
  data () {
    return {
      userId: null
    }
  },
  methods: {
    bookmark: function () {
    },
    mypage: function () {
      location.href = '/mypage?userId=' + this.userId
    },
    todayRecipe: function () {
      location.href = '/today'
    }
  },
  created: function () {
    // Planを取得
    let self = this
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.userId = result['userId']
    if (!this.userId) {
      alert('ユーザーが存在しません、。再度ログインしなおしてください。')
      location.href='/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/success/Success.vue